import 'css-chunksrc/client/scenes/calendar/weeklyView/timeView/styles.scss';export default {
  "timeView": "_timeView_24mee_1",
  "time": "_time_24mee_1",
  "hours": "_hours_24mee_10",
  "event": "_event_24mee_19",
  "dayColumn": "_dayColumn_24mee_24",
  "currentTimeLine": "_currentTimeLine_24mee_35",
  "currentTimeDot": "_currentTimeDot_24mee_46",
  "hoverSlot": "_hoverSlot_24mee_59",
  "creationPreview": "_creationPreview_24mee_69",
  "creationPreviewConnectRight": "_creationPreviewConnectRight_24mee_82",
  "creationPreviewConnectLeft": "_creationPreviewConnectLeft_24mee_87",
  "creationPreviewTime": "_creationPreviewTime_24mee_92"
};